import { useActivityBuilderTheme } from 'approot/activity-builder/theme/activity-builder-theme';
import { MultipleChoiceEditInput } from '../multiple-choice-edit.style';

const MultipleChoiceEditTextField = ({
  index,
  text,
  onChange,
}: {
  index: number;
  text: string | null;
  onChange: (value: string) => void;
}) => {
  const { theme } = useActivityBuilderTheme();

  return (
    <MultipleChoiceEditInput
      maxLength={150}
      $fontSize={theme.font.small.size}
      $lineHeight={theme.font.small.lineHeight}
      placeholder={`Choice ${index + 1}`}
      aria-label={`Choice ${index + 1}.`}
      initialValue={text || ''}
      onChange={event => onChange(event.target.value)}
    />
  );
};

export default MultipleChoiceEditTextField;
